import {
  fetchAuthUser,
  setLanguage,
  setAuthToken,
  setAuth,
  setExpiresIn,
  setTokenCreatedAt,
  setAuthLoggedAs,
  setNavCommunity,
  setAuthUser as setUser
} from "Actions";
import {
  getTTPUser,
  setSelectedOrganization,
  getSelectedOrganization
} from "Api";

import {
  getAuthInfosFromCookie,
  authHasExpired,
  getLocalStorageAuth,
  setLocalStorageAuth
  //redirectToHome
} from "Utils";
import { push } from "react-router-redux";

export const setAuthUser = user => {
  return (dispatch, getState) => {
    dispatch(setAuthToken(user.token));
    dispatch(setExpiresIn(user.expiresIn));
    dispatch(setTokenCreatedAt(user.createdAt));
    dispatch(
      fetchAuthUser(
        getTTPUser({ userId: user.id, token: user.token }).then(res => {
          const user = res.data.data[0];
          dispatch(setLanguage(user.language));
          dispatch(setUser(user));
          dispatch(fetchNavCommunity());
          return user;
        }, err => err)
      )
    );
  };
};

export const login = () => {
  return (dispatch, getState) => {
    let authInfos = getAuthInfosFromCookie();
    if (!authInfos || authHasExpired(authInfos)) {
      setLocalStorageAuth(null);
      //redirectToHome();
    }

    const auth = getLocalStorageAuth();

    if (auth && auth.user && authInfos.token === auth.token) {
      dispatch(setAuth(auth));

      const lng = localStorage.getItem("lng");
      if (!lng || lng.length === 0) {
        dispatch(setLanguage(auth.user.language));
      }
      //dispatch(fetchNavCommunity());
    } else if (authInfos) {
      dispatch(setAuthUser(authInfos));
      dispatch(setAuthLoggedAs("MEMBER"));
    } else {
      dispatch(setAuthLoggedAs("GUEST"));
      if (getState().routing.location.pathname !== "/") {
        dispatch(push("/"));
      }
    }
  };
};

export const changeNavCommunity = organizationId => (dispatch, getState) => {
  const { token } = getState().auth;
  if (!token) {
    return false;
  }
  setSelectedOrganization({
    token,
    organizationId
  });
};

export const fetchNavCommunity = () => (dispatch, getState) => {
  const { token, navCommunity, user } = getState().auth;
  if (!token || !user) {
    return false;
  }

  return getSelectedOrganization(token).then(resp => {
    if (
      resp &&
      resp.data &&
      resp.data.organization &&
      (!navCommunity || navCommunity.id !== resp.data.organization.id)
    ) {
      const { organization } = resp.data;
      const chosed = user.communities.filter(com => organization.id === com.id);
      dispatch(
        setNavCommunity(
          user && user.communities && chosed && chosed.length > 0
            ? chosed[0]
            : organization
        )
      );
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/thunks/auth.js